export interface Country {
  name: string
  code: string
  dialCode: string
  emoji?: string
  flagUrl?: string
}

export const countries: Country[] = [
  {
    name: 'Indonesia',
    code: 'ID',
    dialCode: '+62',
    emoji: '🇮🇩',
    flagUrl: 'https://flagcdn.com/id.svg',
  },
  {
    name: 'Malaysia',
    code: 'MY',
    dialCode: '+60',
    emoji: '🇲🇾',
    flagUrl: 'https://flagcdn.com/my.svg',
  },
]
